enum MensagensDaApiEnum {
  UNCHANGED_PAYLOAD = 'UNCHANGED_PAYLOAD',
}

export default MensagensDaApiEnum
